import { useEffect, useState } from "react"

interface IUseDebounceParams {
    textInput?: string;
    timeout?: number;
}

interface IDebounceReturn {
    setText: (text: string) => void;
    debouncedText: string;
}

/**
 * Retrieves the final text input in an `onChange` event after `params.timeout` milliseconds (default 500 ms)
 * @param {IUseDebounceParams} params Input parameters
 * @returns {IDebounceReturn} Object containing the debounced text in `debouncedText` and the `setText` text setter function
 */
const useDebounce = (params: IUseDebounceParams) => {
    const [text, setText] = useState("");
    const [debouncedText, setDebouncedText] = useState("");

    const textInput = params?.textInput
    const timeout = params?.timeout || 500

    useEffect(() => {
        if (textInput && text) {
            throw new Error('Use only one text entry point')
        }

        const timer = setTimeout(() => {
            const finalText = textInput || text
            setDebouncedText(finalText)
        }, timeout);

        return () => {
            clearTimeout(timer)
        }
    }, [text, textInput]);

    return <IDebounceReturn>{
        setText,
        debouncedText
    }
}

export default useDebounce;
